import { useState } from "react";

import api from "shared/infra/services/api";

import { captureException, captureMessage } from "@sentry/nextjs";

import { useNewGlobalSearch } from "../useNewGlobalSearch";

export const useGetGroups = () => {
  const { updateGroupsList } = useNewGlobalSearch();

  const [isLoadingGroups, setIsLoadingGroups] = useState(false);

  const getGroups = async (org_id) => {
    setIsLoadingGroups(true);
    try {
      const { data } = await api.get("/search/groups", {
        params: {
          org: org_id,
        },
      });

      updateGroupsList(data?.data);
      return data?.data;
    } catch (error) {
      console.log("Error (getGroups): ", error);
      captureException(error);
      captureMessage("Error (getGroups)");

      return null;
    } finally {
      setIsLoadingGroups(false);
    }
  };

  return {
    getGroups,
    isLoadingGroups,
  };
};
